import { Money } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";
import { formatCurrency } from "../intl_helpers";
import type { Model } from "../types";

export default function PriceTooltip({
  cost,
  model,
}: {
  cost: string;
  model: Model;
}) {
  const formattedCost = formatCurrency(cost, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    verboseNegligibleValue: true,
    approximateValue: false,
  });
  return (
    <TooltipProvider showTimeout={0}>
      <TooltipAnchor
        className={"underline cursor-help text-r8-sm flex items-start gap-2"}
        // biome-ignore lint/a11y/useAnchorContent: handled by ariakit
        render={<a href={`/${model.owner}/${model.name}#pricing`} />}
      >
        <Money size={18} className="flex-shrink-0 mt-0.5" />
        <span>{formattedCost} per run</span>
      </TooltipAnchor>
      <Tooltip className={"max-w-72 text-r8-xs z-50"}>
        <TooltipArrow />
        <p className="text-r8-sm">
          This model costs approximately{" "}
          <span className="font-semibold">${cost}</span> to run on Replicate,
          but this may vary depending on the model and your inputs.
        </p>
      </Tooltip>
    </TooltipProvider>
  );
}
